import React, { useState } from 'react'
import { usePopper } from 'react-popper'
import PropTypes from 'prop-types'
import styles from './Badge.module.scss'

const Badge = ({ color = '', text = '', tooltip = '', placement = 'top', Icon, large = false }) => {
    const [arrowRef, setArrowRef] = useState(null)
    const [badge, setBadge] = useState(null)
    const [popper, setPopper] = useState(null)

    const { styles: popperStyles, attributes: popperAttributes } = usePopper(badge, popper, {
        placement: placement,
        modifiers: [
            { name: 'arrow', options: { element: arrowRef } },
            { name: 'offset', options: { offset: [0, 8] } },
        ],
    })

    return (
        <div className={styles.badgeWrapper}>
            <div className={`${text ? styles.badgeFull : styles.badgeIcon} ${large ? styles.largeIcon : ''}`} ref={setBadge}>
                <div className={`${styles.icon} ${styles[color]}`}>{Icon}</div>
                {text && <span className={styles.text}>{text}</span>}
            </div>
            {tooltip && (
                <div className={styles.tooltip} ref={setPopper} style={popperStyles.popper} {...popperAttributes.popper}>
                    {tooltip}
                    <div ref={setArrowRef} style={popperStyles.arrow} className={styles.arrow}></div>
                </div>
            )}
        </div>
    )
}

Badge.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string,
    tooltip: PropTypes.string,
    Icon: PropTypes.object,
    placement: PropTypes.string,
    large: PropTypes.bool,
}

export default Badge
